import { Flex, Text } from "@unifize/sarah";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGroupModalAttributes } from "src/actions/group";
import Icon from "src/components/Icon";
import InlineIcons from "src/icons";
import { getGroup } from "src/reducers";
import * as colors from "src/styles/constants/colors";
import { iconSize } from "src/styles/constants/size";
import type { Nullable } from "src/ts-types";
import { AppState } from "src/types";
import { Image } from "./styles";

interface Props {
  id: number;
}

const Title = ({ id }: Props): Nullable<React.ReactElement> => {
  const dispatch = useDispatch();
  const group = useSelector(({ app }: { app: AppState }) => getGroup(app, id));

  if (!group) return null;

  const { title, photoUrl, owners, members, locked } = group;

  const editGroups = () => {
    dispatch(
      setGroupModalAttributes({
        title,
        photoUrl,
        owners,
        members,
        locked,
        id,
        edit: true,
        show: true,
        error: null,
        loading: false,
      }),
    );
  };

  return (
    <Flex
      cursor="pointer"
      onClick={editGroups}
      style={{ alignItems: "center", width: "max-content" }}
    >
      {photoUrl ? <Image src={photoUrl} alt="" /> : null}
      <Flex
        title={title}
        style={{ alignItems: "center", gap: 8, marginRight: 8 }}
      >
        <Text variant="caption">{title}</Text>
        {locked && <InlineIcons type="lock" />}
      </Flex>
      <Icon icon="edit" size={iconSize.space_s} color={colors.primary} />
    </Flex>
  );
};

export default Title;
